export default __webpack_public_path__ + "static/media/receitas.aaed9f72.svg";